import { render, staticRenderFns } from "./eventAnjiData.vue?vue&type=template&id=6f18b0d6"
import script from "./eventAnjiData.vue?vue&type=script&lang=js"
export * from "./eventAnjiData.vue?vue&type=script&lang=js"
import style0 from "./eventAnjiData.vue?vue&type=style&index=0&id=6f18b0d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports